import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { User } from '../../models/fund/user.model';
import { ApiService } from './api.service';

/**
 * Payload for toggling watchlist (favorites)
 */
export interface ToggleWatchlistPayload {
  entityUUID: string;
  watchlistType: 'ADD' | 'REMOVE';
  fundType: 'ORGANISATION';
}

/**
 * Response from toggle-watchlist API
 */
export interface ToggleWatchlistResponse {
  success: boolean;
  message?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly resourceUrl = '/user';

  constructor(private apiService: ApiService) {}

  getUserDetails(): Observable<User> {
    return this.apiService.get(`${this.resourceUrl}/get-user-info`);
  }

  /**
   * Toggle watchlist (add/remove from favorites)
   * @param payload - The watchlist payload containing entityUUID, watchlistType, and fundType
   * @returns Observable of the API response
   */
  toggleWatchlist(payload: ToggleWatchlistPayload): Observable<ToggleWatchlistResponse> {
    return this.apiService.post(`/v1/users/toggle-watchlist`, payload) as Observable<ToggleWatchlistResponse>;
  }
}
